import membersAPI from "../../../../services/members";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import MeaDataTable from "../../../../components/MeaDataTable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import MeaButton from "../../../../components/MeaButton";
import { Button } from "primereact/button";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import { ToFormatedDateForEvents } from "../../../../utils/dates";
import { useNavigate } from "react-router-dom";
import schoolsAPI from "../../../../services/schools";
import { replaceMailPreviewCidImages } from "../../../../utils/mailPreview";

const MemberMailsComponent = forwardRef((props, ref) => {
  const { currentMembership } = useAuthContext();
  const navigate = useNavigate();
  const [page, setPage] = useState();
  const [pageSize, setPageSize] = useState();
  const [schoolAvatar, setSchoolAvatar] = useState("");
  //
  const queryList = membersAPI.GetMemberMails(props?.schoolId, "", props?.memberId, page, pageSize);
  //
  const [mailBody, setMailBody] = useState("");
  //
  const [previewDialogVisible, setPreviewDialogVisible] = useState(false);
  const previewBody = replaceMailPreviewCidImages(mailBody, schoolAvatar);
  const showPreviewDialog = () => {
    setPreviewDialogVisible(true);
  }
  const hidePreviewDialog = () => {
    setPreviewDialogVisible(false);
  }
  useEffect(() => {
    if (!props?.schoolId) {
      setSchoolAvatar("");
      return;
    }
    schoolsAPI.GetOneSchool(props.schoolId).then((data) => {
      setSchoolAvatar(data?.data?.avatar || "");
    });
  }, [props?.schoolId]);
  //
  const showProfile = (e, item) => {
    e.preventDefault();
    const email = item?.to;
    membersAPI.GetMemberByEmail(props?.schoolId, email).then((data) => {
      console.log(data?.data[0]?.id);
      if (data?.data?.length > 0) {
        navigate(`/school/${props?.schoolId}/admin/members/${data?.data[0]?.id}`);
      }
    });
  }
  //
  useImperativeHandle(ref, () => ({
    refresh: () => {
      queryList?.refetch();
    },
  }));
  //
  return (
    <>
      <Dialog
        visible={previewDialogVisible}
        onHide={hidePreviewDialog}
        maximizable
        modal header="Aperçu de l'email"
        footer={<Button label="Fermer" icon="pi pi-times" onClick={hidePreviewDialog} />}
        contentStyle={{ backgroundColor: 'var(--mea-background-color)' }}
      >
        <div className="flex flex-column p-3 mt-3 h-full" style={{ backgroundColor: 'white' }}>
          <div className="flex-grow-1" >
            {!currentMembership?.is_owner && (
              <div dangerouslySetInnerHTML={{ __html: previewBody.replace(/<a\s+href=["'][^"']*["'][^>]*>/gi, '<a href="#" onclick="return false;">') }}></div>
            )}
            {currentMembership?.is_owner && (
              <div dangerouslySetInnerHTML={{ __html: previewBody }}></div>
            )}
          </div>
        </div>
      </Dialog >
      <MeaDataTable
        query={queryList}
        serviceAPI={membersAPI}
        names={{ pagination: "email", singular: "email", plural: "emails" }}
        showDeleteButton={false}
        //showFilterButton={showFilterButton}
        setPage={setPage}
        setPageSize={setPageSize}
      >
        <Column field="status" header="Statut" body={(item) => (
          <span>
            {(() => {
              switch (item.status) {
                case "SENT":
                  return <><i className="pi pi-check-circle" style={{ color: "green" }}></i> Envoyé</>;
                case "FAILED":
                  return <><i className="pi pi-times-circle" style={{ color: "red" }}></i> Échoué</>;
                case "CANCELLED":
                  return <><i className="pi pi-times-circle" style={{ color: "red" }}></i> Annulé</>;
                case "DRAFT":
                  return <><i className="pi pi-pencil" style={{ color: "blue" }}></i> Brouillon</>;
                case "PENDING":
                  return <><i className="pi pi-clock" style={{ color: "orange" }}></i> En attente</>;
                case "SUBMITTED":
                  return <><i className="pi pi-send" style={{ color: "purple" }}></i> Envoyé</>;
                default:
                  return <><i className="pi pi-question-circle" style={{ color: "gray" }}></i> Inconnu</>;
              }
            })()}
          </span>
        )}
          style={{ width: '10%' }} />
        <Column
          field="subject"
          header="Objet"
        />
        <Column field="error" header="Aperçu" body={(item) => (
          <>
            <MeaButton
              icon="pi pi-eye"
              rounded
              text
              style={{ padding: "0", height: "1.5rem" }}
              onClick={() => {
                setMailBody(item.body);
                showPreviewDialog();
              }}
            //permission={PERMISSION_TRAINING_CAMPAIGN_MAILS.GET}
            />
          </>
        )} />
        <Column field="created_at" header="Date d'envoi " body={(item) => (
          <span>{item.created_at ? <>{ToFormatedDateForEvents(new Date(item.created_at), false)}</> : "-"}</span>
        )} />
        <Column field="last_reaction_at" header="Dernière réaction le" body={(item) => (
          <span>{item.last_reaction_at ? <><i className="pi pi-check-circle" style={{ color: "green" }}></i> {ToFormatedDateForEvents(new Date(item.last_reaction_at), false)}</> : "-"}</span>
        )} />



      </MeaDataTable>
    </>
  );
});

export default MemberMailsComponent;